import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button, FormGroup } from "react-bootstrap";
import "./add-details.css";
import {
  getProductByDemand,
  getPurchase,
  addPurchase,
  getApproveDemandNew,
  searchPurchaseReport,
  getApprovePurchase,
  purchaseById,
  purchaseFromDemandCall,
} from "./AddDetails.actions";
import { connect } from "react-redux";
import { isEmpty, find, filter, isUndefined } from "lodash";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { IconButton } from "@material-ui/core";
import Select from "react-select";
import Swal from "sweetalert";

const AddPurchase = (props) => {
  const [inputField, setInputField] = useState([
    {
      inventoryId: "-1",
      productQuantity: 0,
      productQuantityCount: "",
      productPrice: 0,
      marketPrice: 0,
      inventoryLabel: "",
    },
  ]);

  const [maximumQuantity, setMaximumQuantity] = useState(0);
  const [demandName, setDemandName] = useState("");
  const [purchaseName, setPurchaseName] = useState("");
  const [purchaseDescription, setPurchaseDescription] = useState();
  const [supplier, setSupplier] = useState();
  const [demandNameValue, setDemandNameValue] = useState();
  const [demandNameLabel, setDemandNameLabel] = useState();
  const [purchaseNameValue, setPurchaseNameValue] = useState();
  const [purchaseNameLabel, setPurchaseNameLabel] = useState();
  const [purchaseTax, setPurchaseTax] = useState(0);
  const [ManualPurchaseNumber, setManualPurchaseNumber] = useState(0);
  const [saveId, setSaveId] = useState([]);
  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

  const handleVisible = () => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    Swal({
      title: "Success",
      text: "PurchaseOrder Added Successfully",
      icon: "success",
      button: "Ok",
    });
  };

  const handleDangerVisible = () => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: "Something went Wrong!",
      icon: "error",
      button: "Ok",
    });
  };
  // const getPurchaseList = props.approvePurchaseList.map((x) => {let data = {value: x.purchaseOrderId, label: x.purchaseName}; return data});
  // const getDemandList1 = [isEmpty(props.purchaseListById) ? [] : { value: props.purchaseListById[0].purchase_data[0].create_demand.demandId, label: props.purchaseListById[0].purchase_data[0].create_demand.demandName }];/*
  function uploadPurchase() {
    props.addPurchase(
      {
        demandId: demandName,
        PODescription: purchaseDescription,
        supplier: supplier,
        purchaseName: purchaseName,
        purchaseTax: purchaseTax,
        ManualPurchaseNumber: ManualPurchaseNumber,
        inventoryId: inputField.map((x) => {
          return x.inventoryId;
        }),
        data: inputField.map((x) => {
          let data = {
            inventoryId: x.inventoryId,
            productQuantity: x.productQuantity,
            market_price: x.marketPrice,
          };
          return data;
        }),
      },
      handleVisible,
      handleDangerVisible
    );
    setDemandNameLabel("");
    setManualPurchaseNumber("");
    setPurchaseName("");
    setSupplier("");
    setPurchaseDescription("");
    setPurchaseTax(0);
    setDemandName("-1");
    setPurchaseName("");
    setPurchaseDescription("");
    setSupplier("");
    setInputField([
      {
        inventoryId: "",
        productQuantity: 0,
        productQuantityCount: "",
        productPrice: 0,
        marketPrice: 0,
        inventoryLabel: "",
      },
    ]);
  }

  const getDemandList = props.approveDemandListNew.map((x) => {
    let data = { value: x.demandId, label: x.demandId + " / " + x.demandName };
    return data;
  });

  const inventory = props.porductListDemand.map((x) => {
    let data = {
      value: x.inventoryId,
      label:
        x.inventory.warehouse.whKey +
        "-" +
        x.inventory.category.cateKey +
        "-" +
        x.inventory.invKey +
        " " +
        x.productName,
    };
    return data;
  });

  const getDemand = (selectedOption) => {
    props.getProductByDemand(selectedOption.value);
    setDemandName(selectedOption.value);
    setDemandNameLabel(selectedOption.label);
  };

  const handleChangeDemand = (e, index, type, item) => {
    let z = find(props.porductListDemand, (x) => x.inventoryId == item);
    if (Number(e.target.value) <= Number(z.productQuantity)) {
      const { name, value } = e;
      const list = [...inputField];
      if (type == "intname") list[index]["inventoryId"] = e.value;
      if (type == "intname")
        list[index]["productQuantity"] = Number(z.productQuantity);
      if (type == "intquantity")
        list[index]["productQuantity"] =
          e.target.value < 0
            ? alert("cannot added less than 0")
            : e.target.value;
      // if (type == 'intprice') list[index]['marketPrice'] = e.target.value;

      setInputField(list);
    } else {
      alert("value out of range");
    }
  };

  const handleChange = (e, index, type) => {
    let z = find(props.porductListDemand, (x) => x.inventoryId == e.value);
    const { name, value } = e;
    const list = [...inputField];
    if (type == "intname") list[index]["inventoryId"] = e.value;
    if (type == "intname") list[index]["inventoryLabel"] = e.label;
    if (type == "intname")
      list[index]["productQuantityCount"] = Number(z.productQuantity);
    if (type == "intname")
      list[index]["productPrice"] = Number(z.inventory.productPrice);
    if (type == "intname") setMaximumQuantity(Number(z.productQuantity));
    // if (type == 'intquantity') list[index]['productQuantity'] = e.target.value;
    if (type == "intquantity")
      list[index]["productQuantity"] =
        e.target.value < 0 || e.target.value > Number(z.productQuantity)
          ? alert("value out of range")
          : e.target.value;
    if (type == "intprice") list[index]["marketPrice"] = e.target.value;
    if (type == "intname") setSaveId(e.value);
    setInputField(list);
    //list[index]['productQuantity'] = "";
  };

  const handleAddInput = () => {
    setInputField([
      ...inputField,
      {
        inventoryId: "-1",
        productQuantity: 0,
        productQuantityCount: "",
        productPrice: 0,
        marketPrice: 0,
      },
    ]);
  };

  const handleRemoveInput = (index) => {
    const list = [...inputField];
    list.splice(index, 1);
    setInputField(list);
  };
  const getChecked = (data) => {
    let val =
      !isUndefined(data[0].demand_quantities) &&
      data[0].demand_quantities.map((ar) => ar.productQuantity);
    return false;
  };

  useEffect(() => {
    props.getPurchase();
    props.getApprovePurchase();
    props.getApproveDemandNew();
  }, []);
  return (
    <>
      {props.isFetchningApproveDemandListNew ||
      props.isFetchingProductByDemand ||
      props.isAddingPurchase ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
            {props.isAddingPurchase ? "Saving..." : "Loading..."}
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <Row>
              <Col xl="12" lg="12" md="12" sm="12">
                <Form.Group>
                  <Form.Label>
                    <b>Select Demand *</b>
                  </Form.Label>
                  <Select
                    value={{ label: demandNameLabel }}
                    placeholder="Select Demand..."
                    onChange={(e) => getDemand(e)}
                    options={getDemandList.reverse()}
                    //isOptionDisabled={(option) => !isEmpty(props.approveDemandList) && getChecked(filter(props.approveDemandList, y => y.demandId == option.value))}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xl="12" lg="12" md="12" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Manual Purchase Number *</b>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Manual Purchase Number...."
                    name="Manualpurchase#"
                    min={0}
                    value={ManualPurchaseNumber}
                    onChange={(e) => setManualPurchaseNumber(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xl="12" lg="12" md="12" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Purchaser Name *</b>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Add Purchase Name...."
                    name="purchaseName"
                    value={purchaseName}
                    onChange={(e) => setPurchaseName(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xl="12" lg="12" md="12" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Supplier Name:</b>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Add supplier...."
                    name="supplier"
                    value={supplier}
                    onChange={(e) => setSupplier(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xl="12" lg="12" md="12" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Description:</b>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Add Purchase Description..."
                    name="purchaseDescription"
                    value={purchaseDescription}
                    onChange={(e) => setPurchaseDescription(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xl="12" lg="12" md="12" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Tax(%):</b>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    min={0}
                    max={100}
                    placeholder="Add Purchase Tax..."
                    name="purchaseTax"
                    value={purchaseTax}
                    onChange={(e) => setPurchaseTax(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            {inputField.map((item, i) => {
              return (
                <React.Fragment key={i}>
                  <Row>
                    <Col xl="4" lg="4" md="12" sm="12">
                      <Form.Group>
                        <Form.Label>
                          <b> Select Inventory *</b>
                        </Form.Label>
                        <Select
                          //value={wareHouseId}
                          isDisabled={isEmpty(inventory)}
                          placeholder="Select Inventory..."
                          name="inventoryId"
                          value={{ label: item.inventoryLabel }}
                          onChange={(e) => handleChange(e, i, "intname")}
                          options={inventory}
                          isOptionDisabled={(option) =>
                            !isEmpty(
                              find(
                                inputField,
                                (x) => x.inventoryId == option.value
                              )
                            )
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col xl="2" lg="2" md="6" sm="6">
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <b>Demand Quantity *</b>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          disabled={true}
                          placeholder="Previous Quantity"
                          name="productQuantity"
                          value={item.productQuantityCount}
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="2" lg="2" md="6" sm="6">
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <b>Add Quantity *</b>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Add Quantity...."
                          name="productQuantity"
                          value={item.productQuantity}
                          min={0}
                          onChange={(e) =>
                            handleChangeDemand(
                              e,
                              i,
                              "intquantity",
                              item.inventoryId
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="2" lg="2" md="12" sm="12">
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <b>Stock Price *</b>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Product Price...."
                          name="productPrice"
                          value={item.productPrice}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="2" lg="2" md="12" sm="12">
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <b>Market Price *</b>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Market Price...."
                          name="marketPrice"
                          min={0}
                          value={item.marketPrice}
                          onChange={(e) => handleChange(e, i, "intprice")}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Row>
                      <Col lg="12">
                        {inputField.length - 1 == i && (
                          <IconButton
                            title="Click to Add Demand"
                            onClick={handleAddInput}
                            style={{
                              float: "right",
                              color: "black",
                            }}
                          >
                            <AddIcon />
                          </IconButton>
                        )}

                        {inputField.length !== 1 && (
                          <IconButton
                            title="Click to Remove Demand"
                            onClick={() => handleRemoveInput(i)}
                            style={{ float: "right", color: "black" }}
                          >
                            <RemoveIcon />
                          </IconButton>
                        )}
                      </Col>
                    </Row>
                  </FormGroup>
                </React.Fragment>
              );
            })}
            <div className="sendDiv">
              {demandName=="" ||
              ManualPurchaseNumber==0||
              purchaseName==""||
              inputField[0].inventoryId == "" ||
              inputField[0].productQuantity == 0 ||
              inputField[0].marketPrice==0? (
                <Button
                  disabled
                  style={{
                    marginLeft: "2%",
                    color: "white",
                    width: "20%",
                    backgroundColor: "black",
                    border: "1px solid black",
                  }}
                >
                  Save
                </Button>
              ) : (
                <Button className="sendButton" onClick={uploadPurchase}>
                  Save
                </Button>
              )}
            </div>
          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getPurchase: () => dispatch(getPurchase()),
    addPurchase: (data, handleVisible, handleDangerVisible) =>
      dispatch(addPurchase(data, handleVisible, handleDangerVisible)),
    getProductByDemand: (demandId) => dispatch(getProductByDemand(demandId)),
    getApproveDemandNew: () => dispatch(getApproveDemandNew()),
    searchPurchaseReport: (
      data,
      purchaseName,
      startDate,
      endDate,
      demandName
    ) =>
      dispatch(
        searchPurchaseReport(data, purchaseName, startDate, endDate, demandName)
      ),
    getApprovePurchase: () => dispatch(getApprovePurchase()),
    purchaseById: (data) => dispatch(purchaseById(data)),
    purchaseFromDemandCall: (data) => dispatch(purchaseFromDemandCall(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  warehouseList: state.AddDataReducer.warehouseList,
  categoryList: state.AddDataReducer.categoryList,
  subCategoryList: state.AddDataReducer.subCategoryList,
  inventoryList: state.AddDataReducer.inventoryList,
  demandList: state.AddDataReducer.demandList,
  allInventory: state.AddDataReducer.allInventory,
  isFetchingDemand: state.AddDataReducer.isFetchingDemand,
  isFetchingInventoryAll: state.AddDataReducer.isFetchingInventoryAll,
  porductListDemand: state.AddDataReducer.porductListDemand,
  purchaseList1: state.AddDataReducer.purchaseList1,
  approveDemandListNew: state.AddDataReducer.approveDemandListNew,
  isAddingPurchase: state.AddDataReducer.isAddingPurchase,
  notAddPurchase: state.AddDataReducer.notAddPurchase,
  approvePurchaseList: state.AddDataReducer.approvePurchaseList,
  purchaseListById: state.AddDataReducer.purchaseListById,
  isFetchingSearchPurchaseList:
    state.AddDataReducer.isFetchingSearchPurchaseList,
  isFetchingPurchaseList: state.AddDataReducer.isFetchingPurchaseList,
  purchaseFromDemandData: state.AddDataReducer.purchaseFromDemandData,
  isFetchingProductByDemand: state.AddDataReducer.isFetchingProductByDemand,
  isFetchningApproveDemandListNew:
    state.AddDataReducer.isFetchningApproveDemandListNew,
  isFetchingPurchaseFromDemand:
    state.AddDataReducer.isFetchingPurchaseFromDemand,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPurchase);
